import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Dropdown, Icon, Container, Label } from 'semantic-ui-react';
import { Media } from '../../../../mediaSetting.js';
import PropTypes from 'prop-types';
import Modal from 'components/shared/modal/content';
import PopupHeader from 'components/pages/popupHeader';
import { showAssignTagsModal } from 'actions/modal.js';
import { displayGlobalMessage } from 'actions/globalMessage';
import {
  saveAssignTags,
  clearTempAssignTagsObject,
  updateSelectedTag,
  updateAsssignedValuesByTagId,
  getAvailableTagsByNetworkId,
  getWaitingAreaTags,
} from 'actions/waitingArea.js';
import { sortTagValues } from '../../../../businessLogic/sorting.js';

export default function WaitingAreaAssignTagContent(props) {
  const dispatch = useDispatch();
  const [savingingTagValue, setSavingingTagValue] = useState(false);

  // Values from redux to do calculation/sort
  const availableTagsFromRedux = useSelector(
    (state) => state.waitingAreaReducer.availableTagsByWaitingAreaId.availableTags
  );
  const assignTagValuesFormFromRedux = useSelector((state) => state.waitingAreaReducer.assignTagValuesForm);
  const tagIdFromRedux = useSelector((state) => state.waitingAreaReducer.selectedTagObject.tagId);

  // States for useSelector value set after logic
  const [availableTags, setAvailableTags] = useState(availableTagsFromRedux);
  const [availableTagNames, setAvailableTagNames] = useState();
  const selectedTagObjectRedux = useSelector((state) => state.waitingAreaReducer.selectedTagObject);
  const [assignTagValuesForm, setAssignTagValuesForm] = useState(assignTagValuesFormFromRedux);
  const [availableTagValues, setAvailableTagValues] = useState();

  useEffect(() => {
    setAssignTagValuesForm(assignTagValuesFormFromRedux);
  }, [assignTagValuesFormFromRedux]);

  useEffect(() => {
    setAvailableTags(availableTagsFromRedux);
  }, [availableTagsFromRedux]);

  useEffect(() => {
    let availableTagNamesLocal = [];
    availableTagsFromRedux.map((availableTag) => {
      availableTagNamesLocal.push({
        key: availableTag.tagId,
        text: availableTag.tagName,
        value: availableTag.tagId,
      });
    });
    setAvailableTagNames(availableTagNamesLocal);
  }, [availableTagsFromRedux]);

  useEffect(() => {
    let hasBeenAssignedTagValueIds = [];
    if (!!assignTagValuesFormFromRedux) {
      if (!!assignTagValuesFormFromRedux.tagValuesEdited && assignTagValuesFormFromRedux.tagValuesEdited.length > 0) {
        assignTagValuesFormFromRedux.tagValuesEdited.map((x) => {
          hasBeenAssignedTagValueIds.push(x.tagValueId);
        });
      }
    }

    let availableTagValuesLocal = [];
    let foundAailableTagObject = availableTagsFromRedux.find((x) => {
      return x.tagId === tagIdFromRedux;
    });
    if (foundAailableTagObject) {
      if (hasBeenAssignedTagValueIds.length > 0 && assignTagValuesFormFromRedux.canMultiSelect) {
        foundAailableTagObject.tagValues
          .filter((x) => {
            return !hasBeenAssignedTagValueIds.includes(x.tagValueId);
          })
          .map((availableaTagValue) => {
            availableTagValuesLocal.push({
              key: availableaTagValue.tagValueId,
              text: availableaTagValue.tagValue,
              value: availableaTagValue.tagValueId,
            });
          });
      } else {
        foundAailableTagObject.tagValues.map((availableaTagValue) => {
          availableTagValuesLocal.push({
            key: availableaTagValue.tagValueId,
            text: availableaTagValue.tagValue,
            value: availableaTagValue.tagValueId,
          });
        });
      }
    }
    setAvailableTagValues(availableTagValuesLocal);
  }, [assignTagValuesFormFromRedux]);

  const changeTagNameOption = (event, data) => {
    let selectedAvailableTagObject = availableTags.find((tagObject) => {
      return data.value == tagObject.tagId;
    });
    let selectedTagObject = {};
    if (selectedAvailableTagObject) {
      selectedTagObject = {
        tagId: selectedAvailableTagObject.tagId,
        tagName: selectedAvailableTagObject.tagName,
        canAssignTagValue: selectedAvailableTagObject.canAssignTagValue,
        canMultiSelect: selectedAvailableTagObject.canMultiSelect,
        description: selectedAvailableTagObject.description,
        availableTagValues: selectedAvailableTagObject.tagValues,
      };

      let cb = () => {
        let assignTagValuesObject = {
          tagId: selectedTagObject.tagId,
          tagName: selectedTagObject.tagName,
          canMultiSelect: selectedTagObject.canMultiSelect,
          canAssignTagValue: selectedTagObject.canAssignTagValue,
          description: selectedTagObject.description,
          tagValuesHasBeenSaved: [],
          tagValuesEdited: [],
        };

        dispatch(updateAsssignedValuesByTagId(assignTagValuesObject));
      };
      dispatch(updateSelectedTag(selectedTagObject, cb));
    }
  };

  const cancelAssignTags = () => {
    dispatch(showAssignTagsModal(false));
    dispatch(clearTempAssignTagsObject());
  };

  const multiSelectTagValueOption = (event, data) => {
    let tagValuesArray = assignTagValuesForm.tagValuesEdited;
    if (!!data.value && event.target.type === undefined) {
      let ifTagValueExists = tagValuesArray.find((x) => {
        return x == data.value;
      });
      if (ifTagValueExists == undefined) {
        tagValuesArray.push({
          tagValueId: data.value,
          tagValue: event.target.textContent,
        });
      }
    }
    let updateTagValuesObject = {
      tagValuesEdited: tagValuesArray,
    };
    dispatch(updateAsssignedValuesByTagId(updateTagValuesObject));
  };

  const singleSelectTagValueOption = (event, data) => {
    if (!!data.value) {
      let updateTagValuesObject = {
        tagValuesEdited: [
          {
            tagValueId: data.value,
            tagValue: event.target.textContent,
          },
        ],
      };
      dispatch(updateAsssignedValuesByTagId(updateTagValuesObject));
    }
  };

  const removeATagValue = (tagValueId) => {
    let tagValuesArray = assignTagValuesForm.tagValuesEdited;
    if (!!tagValueId) {
      let foundIndex = tagValuesArray.findIndex((x) => {
        return x.tagValueId === tagValueId;
      });
      if (foundIndex > -1) {
        tagValuesArray.splice(foundIndex, 1);
        let updateTagValuesObject = {
          tagValuesEdited: tagValuesArray,
        };
        dispatch(updateAsssignedValuesByTagId(updateTagValuesObject));
      }
    }
  };

  const saveTagValue = (event) => {
    let cb = (showModal) => {
      let succesfulMessage =
        APP.LANGUAGE.OrganisationalUnitManageTags.AssignTagModal.AssignTagSuccessfulMessage.replace(
          '##tagName##',
          selectedTagObjectRedux.tagName
        );

      let cbAfterGettingTags = () => {
        setSavingingTagValue(false);
        dispatch(showAssignTagsModal(showModal));
        if (!showModal) {
          dispatch(clearTempAssignTagsObject());
          dispatch(
            displayGlobalMessage({
              text: succesfulMessage,
              visible: true,
              messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
              autoHide: true,
            })
          );
        }
      };
      dispatch(getAvailableTagsByNetworkId(props.waitingArea.id));
      dispatch(getWaitingAreaTags(props.waitingArea.id, cbAfterGettingTags));
    };
    if (
      !savingingTagValue &&
      !!assignTagValuesForm.tagValuesEdited &&
      assignTagValuesForm.tagValuesEdited.length > 0 &&
      !event.target.className.includes('disable')
    ) {
      setSavingingTagValue(true);
      let addedTagValuesIdArray = [];
      assignTagValuesForm.tagValuesEdited.map((x) => {
        addedTagValuesIdArray.push(x.tagValueId);
      });

      let newAddedTagObject = {
        tagId: selectedTagObjectRedux.tagId,
        tagName: selectedTagObjectRedux.tagName,
        addedValues: addedTagValuesIdArray,
      };
      dispatch(saveAssignTags(props.waitingArea.id, newAddedTagObject, cb));
    }
  };

  const selectedTagValuesLabelMarkup =
    !!selectedTagObjectRedux && selectedTagObjectRedux.canMultiSelect ? (
      <div className="mrtm">
        <Container fluid as={Media} lessThan="computer">
          <div>
            {sortTagValues(assignTagValuesForm.tagValuesEdited).map((tagValue) => {
              return (
                <Label key={tagValue.tagValueId} className="mrbs mrrs">
                  <Icon name="tag" className="info-color" />
                  <span className="info-color">{tagValue.tagValue}</span>
                  <Icon name="delete" className="info-color" onClick={() => removeATagValue(tagValue.tagValueId)} />
                </Label>
              );
            })}
          </div>
        </Container>
        <Container fluid as={Media} greaterThanOrEqual="computer">
          <div>
            {sortTagValues(assignTagValuesForm.tagValuesEdited).map((tagValue) => {
              return (
                <Label key={tagValue.tagValueId} className="mrbs mrrs">
                  <Icon name="tag" />
                  {tagValue.tagValue}
                  <Icon name="delete" onClick={() => removeATagValue(tagValue.tagValueId)} />
                </Label>
              );
            })}
          </div>
        </Container>
      </div>
    ) : (
      ''
    );
  const btnClasses = 'ui labeled icon button icon left-text mrbnull mrpcrxs color-white mrlnull max-width';
  const rightPanel = (
    <div>
      <div className="ui actions mrtxxs mrbl max-width">
        <button
          tabIndex="3"
          type="button"
          id="save-btn"
          onClick={saveTagValue}
          className={
            savingingTagValue
              ? btnClasses + ' color-button color-button-hover loading'
              : !!assignTagValuesForm.tagValuesEdited && assignTagValuesForm.tagValuesEdited.length > 0
              ? btnClasses + ' color-button color-button-hover'
              : btnClasses + ' color-button disable color-button-hover'
          }
        >
          {APP.LANGUAGE.Save}
          <i className="checkmark icon" />
        </button>
        <button
          tabIndex="4"
          type="button"
          id="cancel-btn"
          onClick={cancelAssignTags}
          className={btnClasses + ' color-bad-things color-bad-things-hover mrtm'}
        >
          <i className="remove icon" />
          {APP.LANGUAGE.Cancel}
        </button>
      </div>
    </div>
  );

  let orgName = props.waitingArea ? props.waitingArea.organisationName : '';
  let waitingAreaName = (props.waitingArea ? props.waitingArea.name : '') + ' (' + orgName + ')';

  return (
    <Modal show={true} hideWhenClickAway={false}>
      <PopupHeader
        helpLink={APP.EXTERNAL_LINKS.ManageTaggings.HelpAssignTags}
        title={APP.LANGUAGE.OrganisationalUnitManageTags.AssignTagModal.Title}
        subtitle={waitingAreaName}
      />
      <div className="content ui form minHeightSmallForm">
        <div className="main-ui-container assign-tags-modal">
          <div id="righthandfloatingpanel">
            <div className="right ui rail">
              <div className="ui sticky">{rightPanel}</div>
            </div>
            {!!availableTagNames && availableTagNames.length > 0 ? (
              <div>
                <div className="placeholder-label no-bold div-like color-placeholder">
                  {APP.LANGUAGE.OrganisationalUnitManageTags.AssignTagModal.TagNameCaption}
                </div>
                <Dropdown
                  className="options-dropdown-equal-length"
                  placeholder={APP.LANGUAGE.OrganisationalUnitManageTags.AssignTagModal.TagNameCaption}
                  onChange={changeTagNameOption}
                  fluid
                  selection
                  options={availableTagNames}
                />
              </div>
            ) : (
              ''
            )}
            {availableTagValues && !!selectedTagObjectRedux.tagId && (
              <div className="mrtm">
                <div className="placeholder-label no-bold div-like color-placeholder">
                  {APP.LANGUAGE.OrganisationalUnitManageTags.AssignTagModal.TagValueDefaultCaption.replace(
                    '##selectedTagName##',
                    selectedTagObjectRedux.tagName
                  )}
                </div>
                {!!selectedTagObjectRedux && selectedTagObjectRedux.canMultiSelect ? (
                  !!availableTagValues && availableTagValues.length === 0 ? (
                    <Dropdown
                      className="options-dropdown-equal-length"
                      placeholder={APP.LANGUAGE.OrganisationalUnitManageTags.EditTagValueModal.EmptyTagValuePlaceHolder}
                      onChange={multiSelectTagValueOption}
                      fluid
                      search
                      selection
                      value={null}
                      disabled
                      options={availableTagValues}
                    />
                  ) : (
                    <Dropdown
                      className="options-dropdown-equal-length"
                      placeholder={APP.LANGUAGE.OrganisationalUnitManageTags.EditTagValueModal.TagValuePlaceholder}
                      onChange={multiSelectTagValueOption}
                      fluid
                      search
                      selection
                      value={null}
                      options={availableTagValues}
                    />
                  )
                ) : (
                  <Dropdown
                    className="options-dropdown-equal-length"
                    onChange={singleSelectTagValueOption}
                    fluid
                    search
                    selection
                    options={availableTagValues}
                  />
                )}
              </div>
            )}
            {selectedTagValuesLabelMarkup}
            <div className="bottom-rail-with-left-and-right-content mrtl">{rightPanel}</div>
          </div>
        </div>
      </div>
    </Modal>
  );
}

WaitingAreaAssignTagContent.propTypes = {
  waitingArea: PropTypes.object.isRequired,
  availableTags: PropTypes.array, // All available tag values for the selected tag
  availableTagNames: PropTypes.array, // All available tag names that do not have saved values
  availableTagValues: PropTypes.array, // All available tag values excluse those has been added
  selectedTagObject: PropTypes.object, // Tag info for the selected one
  assignTagValuesForm: PropTypes.object, // Payload for editing the selected tag including saved values
};
